export class Storage {
  static DB_NAME = 'feedCache';
  static STORE_NAME = 'feeds';
  static VERSION = 5;

  static async init() {
    if (typeof window === 'undefined') return null;
    
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.DB_NAME, this.VERSION);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        
        if (db.objectStoreNames.contains(this.STORE_NAME)) {
          db.deleteObjectStore(this.STORE_NAME);
        }
        
        const store = db.createObjectStore(this.STORE_NAME, { 
          keyPath: 'id',
          autoIncrement: true 
        });
        
        store.createIndex('date', 'date', { unique: false });
        store.createIndex('category', 'category', { unique: false });
        store.createIndex('timestamp', 'timestamp', { unique: false });
      };
    });
  }

  static async loadFeeds() {
    if (typeof window === 'undefined') return [];
    
    try {
      const db = await this.init();
      return new Promise((resolve, reject) => {
        const transaction = db.transaction(this.STORE_NAME, 'readonly');
        const store = transaction.objectStore(this.STORE_NAME);
        const request = store.getAll();

        request.onerror = () => reject(request.error);
        request.onsuccess = () => {
          const items = request.result || [];
          const now = Date.now();
          
          const validItems = items.filter(item => 
            now - (item.timestamp || 0) <= 24 * 60 * 60 * 1000 // 24 hours
          );

          resolve(validItems.sort((a, b) => 
            new Date(b.date).getTime() - new Date(a.date).getTime()
          ));
        };
      });
    } catch (error) {
      console.error('Error loading feeds:', error);
      return [];
    }
  }

  static async saveFeeds(feeds) {
    if (typeof window === 'undefined') return;
    
    try {
      const db = await this.init();
      const transaction = db.transaction(this.STORE_NAME, 'readwrite');
      const store = transaction.objectStore(this.STORE_NAME);

      // Clear existing data
      await store.clear();

      // Add new feeds with timestamp
      const timestamp = Date.now();
      for (const feed of feeds) {
        const { id, ...feedData } = feed;
        await store.add({
          ...feedData,
          timestamp
        });
      }
    } catch (error) {
      console.error('Error saving feeds:', error);
      throw error;
    }
  }

  static async cleanup() {
    if (typeof window === 'undefined') return;
    
    try {
      const db = await this.init();
      const transaction = db.transaction(this.STORE_NAME, 'readwrite');
      const store = transaction.objectStore(this.STORE_NAME);
      const index = store.index('timestamp');
      
      const now = Date.now();
      const range = IDBKeyRange.upperBound(now - (24 * 60 * 60 * 1000));
      
      const request = index.openCursor(range);
      
      request.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          store.delete(cursor.primaryKey);
          cursor.continue();
        }
      };
    } catch (error) {
      console.error('Error cleaning up feeds:', error);
    }
  }
}